export const CONSENT_VERSION = 'v1.0';

export const CATEGORIES = {
  necessary: { key: 'necessary', label: 'Essentiels', default: true, locked: true },
  analytics: { key: 'analytics', label: 'Mesure', default: false },
  marketing: { key: 'marketing', label: 'Marketing', default: false },
  preferences: { key: 'preferences', label: 'Préférences', default: false },
} as const;

export const VENDOR_PATTERNS: Record<string, { cat: keyof typeof CATEGORIES; re: RegExp }[]> = {
  analytics: [
    { cat: 'analytics', re: /googletagmanager\.com|google-analytics\.com|gtag\/js/i },
    { cat: 'analytics', re: /analytics\.google\.com|stats\.g\.doubleclick\.net/i }
  ],
  marketing: [
    { cat: 'marketing', re: /facebook\.net|connect\.facebook\.net|tiktokcdn|tiktok\.com|snap\.com/i },
    { cat: 'marketing', re: /doubleclick\.net|googleadservices\.com/i }
  ],
  preferences: [
    { cat: 'preferences', re: /youtube\.com|youtu\.be|vimeo\.com/i }
  ]
};